import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper';
import 'swiper/swiper-bundle.min.css';
import 'swiper/swiper.min.css';
import 'swiper/components/pagination/pagination.scss';

import useWindowSize from 'hooks/use-windowSize';

import ExploreCareerCard from 'components/pages/career/explorecareercard/ExploreCareerCard';

import classes from './CareerPathsWrapper.module.scss';

const CareerPathsWrapper = ({ careerPaths }) => {
     const { mobileDevice, tabletDevice } = useWindowSize();
    return (
        <div className={classes['wrapper']}>
            <h3 className="text-2xl font-bold mb-4">Don’t know where to start?</h3>
            <p>
                Take a look at our career paths:
            </p>
            <Swiper
                slidesPerView={mobileDevice ? 1.1 : tabletDevice ? 1.8 : 2.1}
                spaceBetween={20}   
                style={{ padding: '20px' }}   
                >
                {careerPaths.map((careerPath, index) => (
                    <SwiperSlide style={{ height: 'auto', overflow: 'visible' }} key={index}>
                        <div className={classes['card-wrapper']}>
                            <ExploreCareerCard key={index} career={careerPath} />
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>


        </div>
    );
};

export default CareerPathsWrapper;